namespace Matrix.Data {

    @Serenity.Decorators.element("<div/>")
    @Serenity.Decorators.editor()
    export class StoredProcParametersEditor extends SiteEntityGrid<DataParameter, any> {

        getColumnsKey() { return "Data.StoredProcParameters"; }
        getIdProperty() { return "Name"; }
        private editingHelper: GridEditingHelper;

        constructor(container) {
            super(container);

            this.element.addClass('editable-data-grid');
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.editingHelper = new GridEditingHelper(this.element, this.slickGrid, true);
        }

        private inputsChange(e: JQueryEventObject) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row) as DataParameter;
            var input = $(e.target);
            item.DefaultValue = input.val();
            this.view.updateItem(item.Name, item);
        }

        getPersistanceStorage() {
            return null;
        }

        getInitialTitle() {
            return null;
        }

        getGridCanLoad() {
            return false;
        }

        protected getButtons() {
            return null;
        }

        protected createQuickSearchInput() {
        }

        protected usePager() {
            return false;
        }

        protected getColumns() {
            var columns = super.getColumns();
            var dv = Q.tryFirst(columns, x => x.field == "DefaultValue");
            dv && (dv.format = ctx => {
                return `<input class="edit" type="text" value="${Q.attrEncode(ctx.value)}" />`;
            });
            return columns;
        }

        public getParameterValues() {
            var items = this.view.getItems();
            var values: Q.Dictionary<string> = {};
            for (var x of items)
                values[x.Name] = x.DefaultValue;
            return values;
        }
    }
}